export default "__VITE_ASSET__B6aQ76ZD__"